import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import UserCircleIcon from 'components/v2/icons/UserCircleIcon';
import UserGroupIcon from 'components/v2/icons/UserGroupIcon';
import VerticalNav from 'components/v2/navs/VerticalNav';
import BellIcon from 'components/v2/icons/BellIcon';
import SquaresPlusIcon from 'components/v2/icons/SquarePlusIcon';
import ChatAltIcon from 'components/v2/icons/ChatAltIcon';
import TruckIcon from 'components/v2/icons/TruckIcon';
import { CurrencyDollarIcon } from '@heroicons/react/24/outline';
import { getIsNewFscFlow } from 'utils/FscSettingsApiUtils';
const Sidebar = ({ userId, activePage, t }) => {
    const [isNewFscFlow, setIsNewFscFlow] = useState(null);
    function isActive(page) {
        return activePage === page;
    }
    useEffect(() => {
        (async () => {
            const isNewFscFlow = await getIsNewFscFlow();
            setIsNewFscFlow(isNewFscFlow);
        })();
    }, []);
    const profileActive = isActive('profile');
    const ratesActive = isActive('rates');
    const integrationsActive = isActive('integrations');
    const driversActive = isActive('drivers');
    const notificationsActive = isActive('notifications');
    const activityActive = isActive('activity');
    const billingActive = isActive('billing');
    const quickpayActive = isActive('quickpay');
    const teamActive = isActive('team');
    return (React.createElement(VerticalNav, null,
        React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}`, active: profileActive, title: titleize(t('PROFILE', { count: 1 })) }, (iconClassName) => (React.createElement(UserCircleIcon, { size: "medium", className: iconClassName }))),
        React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}/carrier-settings/drivers`, active: driversActive, title: titleize(t('DRIVER', { count: 2 })) }, (iconClassName) => (React.createElement(TruckIcon, { size: "medium", className: iconClassName }))),
        React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}/carrier-settings/team`, active: teamActive, title: t('TEAM') }, (iconClassName) => (React.createElement(UserGroupIcon, { type: "outline", className: iconClassName }))),
        React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
            React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}/carrier-settings/billing`, active: billingActive, title: t('BILLING') }, (iconClassName) => (React.createElement(SquaresPlusIcon, { type: "outline", className: iconClassName })))),
        React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
            React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}/carrier-settings/quick-pay`, active: quickpayActive, title: t('QUICK_PAY') }, (iconClassName) => (React.createElement(SquaresPlusIcon, { type: "outline", className: iconClassName })))),
        isNewFscFlow && (React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}/settings/rates`, active: ratesActive, title: t('RATES_SETTINGS') }, (iconClassName) => (React.createElement(CurrencyDollarIcon, { type: "outline", className: iconClassName })))),
        React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
            React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}/carrier-settings/integrations`, active: integrationsActive, title: t('INTEGRATION', { count: 2 }) }, (iconClassName) => (React.createElement(SquaresPlusIcon, { type: "outline", className: iconClassName })))),
        React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}/carrier-settings/notifications`, active: notificationsActive, title: titleize(t('NOTIFICATION', { count: 2 })) }, (iconClassName) => (React.createElement(BellIcon, { size: "medium", className: iconClassName }))),
        React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}/carrier-settings/activity`, active: activityActive, title: titleize(t('ACTIVITY')) }, (iconClassName) => (React.createElement(ChatAltIcon, { type: "outline", className: iconClassName })))));
};
Sidebar.propTypes = {
    userId: PropTypes.string,
    activePage: PropTypes.string,
};
Sidebar.defaultProps = {
    activePage: 'profile',
};
export default withTranslation()(Sidebar);
